import React, { useEffect, useState } from "react";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import { db } from "../firebaseConfig";
import Modal from "react-modal";
import ResumenCotizacion from "./ResumenCotizacion";
import ResumenOrden from "./ResumenOrden";
import ResumenRemision from "./ResumenRemision";
import { useFunctionsPrevia } from "../hooks/useFunctionsPrevia"; 

const ArchivosRecientes = () => {
  const [archivos, setArchivos] = useState([]);
  const [selectedArchivo, setSelectedArchivo] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const { formatDate } = useFunctionsPrevia();

  useEffect(() => {
    const colecciones = [
      {
        nombre: "cotizaciones",
        fechaCampo: "fechaCotizacion",
        tipo: "Cotización",
      },
      { nombre: "ordenes", fechaCampo: "fechaOrden", tipo: "Orden" },
      { nombre: "remisiones", fechaCampo: "fechaRemision", tipo: "Remisión" },
    ];
    const unsubscribes = [];

    const obtenerArchivos = () => {
      const archivosTotales = [];

      colecciones.forEach(({ nombre, fechaCampo, tipo }) => {
        const q = query(collection(db, nombre), orderBy("createdAt", "desc"));

        const unsubscribe = onSnapshot(q, (snapshot) => {
          const datos = snapshot.docs.map((doc) => ({
            id: doc.id,
            nombre:
              doc.data().nombreCliente ||
              doc.data().nombreProveedor ||
              "Desconocido",
            fecha: doc.data()[fechaCampo],
            estado: doc.data().estado || "Sin estado",
            total: doc.data().total || 0,
            usuario:
              doc.data().vendedorNombre || doc.data().comprador || "Sin nombre",
            tipo,
            createdAt: doc.data().createdAt?.toMillis() || 0,
            datos: doc.data(),
          }));

          archivosTotales.push(...datos);

          const archivosOrdenados = archivosTotales
            .sort((a, b) => b.createdAt - a.createdAt)
            .slice(0, 5); // Selecciona solo los 5 más recientes

          setArchivos(archivosOrdenados);
        });

        unsubscribes.push(unsubscribe);
      });
    };
    obtenerArchivos();

    return () => {
      unsubscribes.forEach((unsub) => unsub());
    };
  }, []);

  const handleRowClick = (archivo) => {
    setSelectedArchivo(archivo);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedArchivo(null);
    setModalOpen(false);
  };

  function formatTotal(amount) {
    if (isNaN(amount)) return "0.00"; // Maneja casos donde el total no es un número
    return parseFloat(amount)
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return (
    <div style={{ paddingLeft: "70px", marginBottom: "20px" }}>
      <div className="proyectos-section">
        <h3 className="proyectos-title">Archivos Recientes</h3>
        <div className="proyectos-header">
          <div className="header-actions-proyectos">
            <button className="action-button-proyectos">
              <i className="bi bi-funnel-fill"></i> Todos
              <i
                className="bi bi-chevron-down"
                style={{ fontSize: "12px" }}
              ></i>
            </button>
            <div className="buscador-pedidos">
              <i className="bi bi-search"></i>
              <input
                type="text"
                className="buscador-input"
                placeholder="Buscar"
              />
            </div>
          </div>

          <div>
            <button className="exportar-button">
              <i
                className="bi bi-cloud-arrow-down"
                style={{ marginRight: "5px" }}
              ></i>
              Exportar
            </button>

            <button className="new-proyecto-button">+ Crear Nuevo</button>
          </div>
        </div>

        <div className="proyecto-list-container">
          <table className="proyecto-tabla">
            <thead>
              <tr>
                <th>NOMBRE</th>
                <th>USUARIOS</th>
                <th>FECHA</th>
                <th>TOTAL</th>
                <th>TIPO</th>
              </tr>
            </thead>
            <tbody>
              {archivos.length > 0 ? (
                archivos.map((archivo) => (
                  <tr
                    key={archivo.id}
                    onClick={() => handleRowClick(archivo)}
                    style={{ cursor: "pointer" }}
                  >
                    <td className="ellipsis">{archivo.nombre}</td>
                    <td>
                      <div className="avatar-group">
                        {/* Podrías usar un solo avatar, o mapear si tuvieras un array */}
                        <img
                          src="/img/avatar2.jpg"
                          alt="Avatar por defecto"
                          className="avatarOrden"
                        />
                      </div>
                    </td>

                    <td>
                      <div className="estilos-fechas">
                        {formatDate(archivo.fecha)}
                      </div>
                    </td>
                    <td>{formatTotal(archivo.total)}</td>
                    <td>{archivo.tipo}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No hay archivos recientes</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      <Modal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        contentLabel="Vista de Archivo"
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "70%",
            height: "80%",
            "::WebkitScrollbar": {
              width: "0px",
              background: "transparent",
            },
            /* Ocultar scrollbar en IE y Edge */
            msOverflowStyle: "none",
            /* Ocultar scrollbar en Firefox */
            scrollbarWidth: "none",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 101,
          },
        }}
      >
        {selectedArchivo && selectedArchivo.tipo === "Cotización" && (
          <ResumenCotizacion
            cotizacion={selectedArchivo.datos}
            isOpen={modalOpen}
            onClose={closeModal}
          />
        )}
        {selectedArchivo && selectedArchivo.tipo === "Orden" && (
          <ResumenOrden
            orden={selectedArchivo.datos}
            isOpen={modalOpen}
            onClose={closeModal}
          />
        )}
        {selectedArchivo && selectedArchivo.tipo === "Remisión" && (
          <ResumenRemision
            remision={selectedArchivo.datos}
            isOpen={modalOpen}
            onClose={closeModal}
          />
        )}
      </Modal>
    </div>
  );
};

export default ArchivosRecientes;
